import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { Moment } from 'moment';
import { PromotionDataService } from 'src/app/services/promotion-data.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import Swal from 'sweetalert2';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-remove-promotion',
  templateUrl: './remove-promotion.component.html',
  styleUrls: ['./remove-promotion.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class RemovePromotionComponent implements OnInit {
  form: FormGroup
  attachmentform: FormGroup
  promocodelist: any[];
  filteredList: any[];
  minDate: Date
  maxDate: Date
  @ViewChild('startDate') startDatePicker: MatDatepicker<Date>;
  date = new FormControl(moment());
  file: File;
  isFileSelected: boolean = false
  constructor(
    private formBuilder: FormBuilder,
    private promotionservice: PromotionDataService,
    private toaster: NotificationService,
  ) { }

  ngOnInit() {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()

    this.minDate = new Date(year, month, 1)
    this.maxDate = new Date(year, month + 1, 0)
    this.form = this.formBuilder.group({
      promoId: [null, Validators.required],
      month: [null]
    })
    this.promotionservice.getActivePromotions().subscribe((result) => {
      this.promocodelist = result;
      this.filteredList = [...this.promocodelist]
    })
    this.attachmentform = this.formBuilder.group({
      AttachmentFileName: [null]
    })
  }
  reset() {
    this.form.reset()
  }
  GetExcel() {
    if (this.form.valid) {
      this.promotionservice.getPromoApplicationList(this.form.value).subscribe((result) => {
        if (result) {
          const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + result;
          const downloadLink = document.createElement('a');
          const fileName = 'Promotion_End_Applications.xlsx';
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      })
    }
  }
  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value?.clone() ?? moment();
    ctrlValue.year(normalizedMonthAndYear.year());
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.date(1); // Reset day to 1st of the month (optional but safer)
    this.form.controls['month'].setValue(ctrlValue); // Make sure form is initialized correctly
    this.date.setValue(ctrlValue); // Optional: keep local variable in sync
    datepicker.close();
  }
  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();
    let fileName = null
    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }
      this.file = files[0];
      fileName = this.file.name;
      const fileExtension = fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.isFileSelected = true;
      this.attachmentform.controls['AttachmentFileName'].setValue(fileName);
      console.log(this.file);
      document.body.removeChild(inputElement);
    });
  }
  remove() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.isFileSelected = false;
        this.attachmentform.controls['AttachmentFileName'].setValue('');
      }
    });
  }

  upload() {
    if (this.file) {
      let formdata: FormData = new FormData();
      formdata.append("file", this.file)
      formdata.append('BatchProcessModuleType', BatchProcessModuleType.RevokePromotion.toString());
      this.promotionservice.uploadRevokePromoList(formdata).subscribe((result) => {
        if (result) {
          this.toaster.showSuccess('Excel Uploaded Succesfully')
        }

      })
    }
  }

}

